import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-irsaliye-lojistik-rota-fiyat',
  templateUrl: './irsaliye-lojistik-rota-fiyat.component.html',
  styleUrls: ['./irsaliye-lojistik-rota-fiyat.component.css']
})
export class IrsaliyeLojistikRotaFiyatComponent implements OnInit {

  constructor(private route: ActivatedRoute, private restApi:RestService) { }

  lojistikId: number = 0;
  lojistikIrsaliyeList:any;

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.lojistikId = params.id;
      if (this.lojistikId > 0) {
        this.irsaliyeGetir(this.lojistikId)
      }
    });

  }


  /**
   * Taşımacı firmasına göre irsaliye getirmek için kullanılır
   * @param id lojistikId
   */
  irsaliyeGetir(id: number) {
    this.restApi.getLojistik(id).subscribe(res => {
      this.restApi.cariDetay(res.cariId).subscribe(cari => {
        this.restApi.getLojistikIrsaliyeListByVkn(cari.vergiNo).subscribe(irsaliyeList => {
          this.lojistikIrsaliyeList = {};
          this.lojistikIrsaliyeList.lojistikIrsaliyeList = irsaliyeList;
          this.lojistikIrsaliyeList.lojistikIrsaliyeList.forEach(i=>{ 
            let x = null
            if(i.lojistik.colInt == -1) x = null
            else if(i.lojistik.colInt == 0) x = false
            else if(i.lojistik.colInt == 1) x = true
            Object.assign(i.lojistik,{donus:x})
          })
          console.log(this.lojistikIrsaliyeList.lojistikIrsaliyeList)
          this.lojistikIrsaliyeList.mazotBazFiyati = res.mazotBazFiyati;
          this.lojistikIrsaliyeList.permission = true;
        })
      })
    })
  }
}
